import React from 'react';
import PropTypes from 'prop-types';
import { BlockContextMenuComponent } from './BlockContextMenu.styles';

export const BlockContextMenu = ({ children, blockPointerEvents = true, className = '' }) => {
  return (
    <BlockContextMenuComponent
      blockPointerEvents={blockPointerEvents}
      onContextMenu={(e) => e.preventDefault()}
      className={className}
    >
      {children}
    </BlockContextMenuComponent>
  );
};

BlockContextMenu.propTypes = {
  children: PropTypes.node,
  blockPointerEvents: PropTypes.bool,
  className: PropTypes.string,
};

export default BlockContextMenu;
